import React, {useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {VisitRequestDto} from "../../../modules/vms/dto/VisitRequestDto";
import Descriptions from "../../../components/Descriptions";
import DescriptionItem from "../../../components/DescriptionItem";
import {Button, Card, CardContent, CardHeader} from "@mui/material";
import {RequestVisitorDto} from "../../../modules/vms/dto/RequestVisitorDto";
import {VisitorAccessLogDto} from "../../../modules/vms/dto/VisitorAccessLogDto";
import StringUtils from "../../../utils/StringUtils";
import VisitorRequestInfoCardDialog from "./VisitorRequestInfoCardDialog";
import {HttpStatus} from "../../../modules/common/enums/HttpStatus";
import {MessageUtils} from "../../../utils/MessageUtils";
import {RequestVisitorApi} from "../../../modules/vms/api/RequestVisitorApi";

export type VisitorRequestInfoProps = {
    visitRequest: VisitRequestDto;
    requestVisitor: RequestVisitorDto;
    onUpdatedVisitor?: () => void
};

const VisitorRequestInfo: React.FC<VisitorRequestInfoProps> = (props) => {
    const intl = useIntl();

    const [openCardDialog, setOpenCardDialog] = useState(false);

    const checkOutLog = props.requestVisitor.checkOutLog && Object.assign(new VisitorAccessLogDto(), props.requestVisitor.checkOutLog);
    const checkInLog = props.requestVisitor.checkInLog && Object.assign(new VisitorAccessLogDto(), props.requestVisitor.checkInLog);

    const _handleSaveCardNumber = async (cardNumber: string) => {
        props.requestVisitor.accessCardNumber = cardNumber;
        const responseResult = await RequestVisitorApi.checkinRegister(props.requestVisitor);
        if (responseResult) {
            if (responseResult.status === HttpStatus.SUCCESS) {
                MessageUtils.success(intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER_BIND_SUCCESS'}))
                setOpenCardDialog(false);
                if (props.onUpdatedVisitor) {
                    props.onUpdatedVisitor();
                }
            } else {
                console.log(responseResult)
            }
        }
    }

    return (
        <Card>
            <VisitorRequestInfoCardDialog open={openCardDialog} onCancel={() => setOpenCardDialog(false)}
                                          onOk={(value) => _handleSaveCardNumber(value)}/>
            <CardHeader title={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VISIT_REQUEST_INFO'})}/>
            <CardContent>
                <Descriptions>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_NUMBER'})}>
                        {props.visitRequest.number}
                    </DescriptionItem>

                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_ARRIVE_START_DATE'})}>
                        {StringUtils.formatDate(props.visitRequest?.arriveStartDate)}
                    </DescriptionItem>
                    {/*<DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_ARRIVE_END_DATE'})}>*/}
                    {/*    {StringUtils.formatDate(props.visitRequest?.arriveEndDate) + " " + StringUtils.formatTime(props.visitRequest?.arriveEndTime)}*/}
                    {/*</DescriptionItem>*/}
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_VISIT_CODE'})}>
                        {props.requestVisitor.visitCode}
                    </DescriptionItem>
                    {/*<DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_CHECKIN_TIME'})}>*/}
                    {/*    /!*{checkInLog?.fetchAccessDateTime()}*!/*/}
                    {/*    {StringUtils.formatDate(props.requestVisitor.checkInLog?.accessDate) + " " + StringUtils.formatTime(props.requestVisitor.checkInLog?.accessTime)}*/}
                    {/*</DescriptionItem>*/}
                    {/*<DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_CHECKOUT_TIME'})}>*/}
                    {/*    /!*{checkOutLog?.fetchAccessDateTime()}*!/*/}
                    {/*    {StringUtils.formatDate(props.requestVisitor.checkOutLog?.accessDate) + " " + StringUtils.formatTime(props.requestVisitor.checkOutLog?.accessTime)}*/}
                    {/*</DescriptionItem>*/}
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER'})}>

                        {props.requestVisitor.accessCardNumber ? props.requestVisitor.accessCardNumber :
                            <Button size={'small'} variant={'outlined'} onClick={() => setOpenCardDialog(true)}>
                                <FormattedMessage id={'VMS_REQUEST_VISITOR_ACCESS_CARD_NUMBER_BIND'}/>
                            </Button>}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_PURPOSE'})}>
                        {props.visitRequest.purpose}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ACCESS_IN_TIME'})}>
                        {StringUtils.formatDate(props.requestVisitor.accessInLog?.accessDate) + " " + StringUtils.formatTime(props.requestVisitor.accessInLog?.accessTime)}
                    </DescriptionItem>
                    <DescriptionItem label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ACCESS_OUT_TIME'})}>
                        {StringUtils.formatDate(props.requestVisitor.accessOutLog?.accessDate) + " " + StringUtils.formatTime(props.requestVisitor.accessOutLog?.accessTime)}
                    </DescriptionItem>
                    {/*<DescriptionItem label={intl.formatMessage({id: 'VMS_VISIT_REQUEST_SITE'})}>*/}
                    {/*    {props.visitRequest.siteName}*/}
                    {/*</DescriptionItem>*/}
                </Descriptions>
            </CardContent>
        </Card>
    );
};

export default VisitorRequestInfo;
